<template>
  <v-app>
    <v-app-bar
      color="primary"
      dense
      app
      absolute
      class="mb-2 pb-2"
    >
      <div class="d-flex align-center">
        <router-link to="/">{{text.appBarText}}</router-link>
      </div>  
      <v-spacer></v-spacer>
    
    </v-app-bar>
    
    
    <v-main>  
      <router-view v-bind:text="text" />
    </v-main>

    <Footer
    v-bind:copyRigth="text.copyRigth"
    v-bind:bottomNote="text.bottomNote"
    v-bind:contactEmail="text.contactEmail"
    />

  </v-app>
</template>

<script>
import Footer from "./components/footer.vue";
export default {
    name: 'App',
    components: { Footer },
    data() {
        return {
            text: '',
        }
    },
    methods: {
        getData() {
            let path = "/text.json";
            fetch(path)
            .then(res => res.json())
            .then((out) => {
               this.text = out;
            })
            .catch(err => { throw err });
        }
    },
    mounted() {
        this.getData();
    }
    
}
</script>



<style scoped>
.v-application a {
  color: black;
  text-decoration: none;
}

</style>>